/** Raw MATLAB recording data accompanies a video; it is not a standalone chart document. */
export const MATLAB_DATA_CONTENT_TYPE = "application/x-matlab-data";
